module.exports = __webpack_public_path__ + "img/20190612_132334_026.25489b48.jpg";